import {AxiosResponse} from 'axios';
//api
import {orgAPI} from '@/core/api';
//types
import {IUserOrganizationSettingData, IRequestAddVipPhone, IVipPhoneData} from '@/utils/types';
//enum
import {API_URL} from '../enums/api-url.enum';

class OrganizationNotificationSettingService {
	static getAllVipPhones = async (organizationId: number): Promise<AxiosResponse<IVipPhoneData[]>> =>
		orgAPI.get(`${API_URL.VIP_PHONES}/${organizationId}`);

	static createVipPhones = async (reqBody: IRequestAddVipPhone): Promise<AxiosResponse<IVipPhoneData>> =>
		orgAPI.post(API_URL.VIP_PHONE, reqBody);

	static deleteVipPhones = async (numberId: number): Promise<AxiosResponse> =>
		orgAPI.delete(`${API_URL.VIP_PHONE}?numberId=${numberId}`);

	static getAllNotificationSetting = async (
		organizationId: number
	): Promise<AxiosResponse<IUserOrganizationSettingData>> =>
		orgAPI.get(`${API_URL.NOTIFICATION_SETTING}/${organizationId}`);

	static updateNotificationSetting = async (
		id: number,
		reqBody: IUserOrganizationSettingData
	): Promise<AxiosResponse<IUserOrganizationSettingData>> => orgAPI.put(`${API_URL.NOTIFICATION_SETTING}/${id}`, reqBody);
}

export {OrganizationNotificationSettingService};
